import { isMobile } from './util';
import QRCode from 'qrcode';

export function qrcodeGen(el, link, width) {
  if (isMobile() || !el || !link) return;
  width = width || 145;
  QRCode.toCanvas(
    el,
    link,
    {
      width: width,
      height: width,
      margin: 1,
      color: {
        dark: '#000',
        light: '#fff' // Transparent background
      }
    },
    function(error) {
      if (error) console.error(error);
      console.log('success!');
    }
  );
}
